import ClientFeedbackForm from "@/components/feedback/client-feedback-form";
import { useLocalSearchParams } from "expo-router";
import Drawer from "expo-router/drawer";
import { Text, View, ActivityIndicator } from "react-native";
import { KeyboardAwareScrollView, KeyboardToolbar } from "react-native-keyboard-controller";
import { trpc } from "@/trpc/react";
import { useMemo } from "react";

export default function ClientFeedbackPage() {
  const { id } = useLocalSearchParams();
  const jobDateId = Number(id);

  const { data: jobDataResult, isLoading } = trpc.jobDateListRouter.getById.useQuery(jobDateId);
  const jobData = useMemo(() => jobDataResult?.data, [jobDataResult?.data]);

  const { data: jobClientResult, isLoading: clientLoading } = trpc.clientFeedback.getJobClientByJobDate.useQuery(jobDateId);
  const jobClient = useMemo(() => jobClientResult, [jobClientResult]);

  if (isLoading || clientLoading) {
    return (
      <>
        <Drawer.Screen
          options={{
            title: 'Client Feedback',
          }}
        />
        <View className="flex-1 justify-center items-center bg-background">
          <ActivityIndicator size="large" color="#888888" />
        </View>
      </>
    );
  }

  if (!jobData || !jobClient) {
    return (
      <>
        <Drawer.Screen
          options={{
            title: 'Client Feedback',
          }}
        />
        <View className="flex-1 justify-center items-center bg-background p-4">
          <Text className="text-xl text-foreground font-bold text-center">
            No client information available for this job
          </Text>
        </View>
      </>
    );
  }

  return (
    <>
      <Drawer.Screen
        options={{
          title: 'Client Feedback',
        }}
      />
      <KeyboardAwareScrollView
        bottomOffset={62}
        className="flex-1 bg-background p-4"
        contentContainerStyle={{
          gap: 20,
          paddingTop: 40,
        }}
      >
        <Text className="text-xl text-foreground font-extrabold tracking-tight self-start">
          Provide feedback for {jobClient.client?.name || 'client'}
        </Text>
        <ClientFeedbackForm
          jobId={jobClient.id}
          jobDateId={jobDateId}
        />
      </KeyboardAwareScrollView>
      <KeyboardToolbar />
    </>
  );
}
